export function toCamelCase(str:string) {
	str = str.replace(/[-_\s]+(.)?/g, (match, ch) => // eslint-disable-line no-param-reassign
		(ch ? ch.toUpperCase() : ''),
	);

	// Ensure first chat is always lowercase
	return str.substr(0, 1).toLowerCase() + str.substr(1);
};

export function toKebabCase (string:string) {
	return string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();

}